(() => {
  if (customElements.get('ls-creator-video')) return;
  customElements.define('ls-creator-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const launch = this.querySelector('.creator-videos__launch');
      const error = this.querySelector('.creator-videos__error');
      if (!video || !launch) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const showPreview = () => {
        video.controls = false;
        launch.hidden = false;
        this.setAttribute('data-preview', '');
      };
      const showPlayer = () => {
        this.removeAttribute('data-preview');
        launch.hidden = true;
        video.controls = true;
        error.hidden = true;
      };
      const showError = () => {
        showPreview();
        error.textContent = this.dataset.error;
        error.hidden = false;
        launch.disabled = false;
      };
      showPreview();
      launch.addEventListener('click', async () => {
        launch.disabled = true;
        error.hidden = true;
        try {
          if (video.error) video.load();
          await video.play();
          if (!this.isConnected) return;
          showPlayer();
          video.setAttribute('tabindex', '0');
          video.focus({ preventScroll: true });
        } catch {
          if (this.isConnected) showError();
        } finally {
          launch.disabled = false;
        }
      }, options);
      video.addEventListener('play', () => {
        showPlayer();
        document.querySelectorAll('ls-creator-video video').forEach(other => {
          if (other !== video) other.pause();
        });
      }, options);
      video.addEventListener('error', showError, options);
      video.addEventListener('ended', showPreview, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.querySelector('video')?.pause();
    }
  });
})();
